import { render } from "./RecycleHistoryItem.vue?vue&type=template&id=470e7742&scoped=true"
import script from "./RecycleHistoryItem.vue?vue&type=script&lang=ts"
export * from "./RecycleHistoryItem.vue?vue&type=script&lang=ts"

import "./RecycleHistoryItem.vue?vue&type=style&index=0&id=470e7742&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-470e7742"

export default script